// extracted by mini-css-extract-plugin
export var cardContainer = "_pr-0";
export var cardHeader = "_pr-2";
export var collapsedState = "_pr-3";
export var dragHandle = "_pr-5";
export var dragHandleIcon = "_pr-6";
export var dragging = "_pr-1";
export var titleArea = "_pr-4";